export default __webpack_public_path__ + "static/media/logo.d108f6c7.svg";